import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './NotPartnerAccountPlaceholder.module.scss'

interface IProps {}

export const NotPartnerAccountPlaceholder = ({}: IProps) => {
  return (
    <div className={styles.content}>
      <div className={styles.image}>
        <i className={'hpicon hpicon-sat3'}></i>
      </div>
      <div className={styles.message}>
        <h3>
          <Translation htmlAvailable text="jbp-no-partner-user" />
        </h3>
      </div>
    </div>
  )
}
